var map = {
	"./about-app/game.svg": 866,
	"./about-app/learn.svg": 867,
	"./about-app/scan.svg": 868,
	"./about-app/tips.svg": 869,
	"./arrow.svg": 775,
	"./bt-round-active.svg": 784,
	"./bt-round-hover.svg": 785,
	"./bt-round.svg": 786,
	"./check-box-checked.svg": 774,
	"./close.svg": 870,
	"./contract.svg": 871,
	"./done.svg": 787,
	"./download.svg": 872,
	"./east-arrow.svg": 776,
	"./email.svg": 873,
	"./feedback.svg": 397,
	"./game.svg": 874,
	"./go.svg": 875,
	"./menu.svg": 876,
	"./next.svg": 877,
	"./polygon_arrow.svg": 779,
	"./search.svg": 878,
	"./sign.svg": 398,
	"./vertical_dots.svg": 773,
	"./words-containing-outlined.svg": 879
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 865;